import { useLanguage } from '@/contexts/LanguageContext';
import { OrgAlert } from '@/components/common/OrgAlert';
import { SubscribeButton } from '@/components/billing/SubscribeButton';

interface TrialExpirationAlertContentProps {
  daysRemaining: number;
}

/**
 * Alert content for trials expiring within 7 days.
 * Shows a warning with the number of days remaining and a subscribe button.
 */
export function TrialExpirationAlertContent({ daysRemaining }: TrialExpirationAlertContentProps) {
  const { t } = useLanguage();

  return (
    <OrgAlert variant="warning" title={t.billing.trialExpirationAlert.alertTitle}>
      <p className="text-xs">
        {t.billing.trialExpirationAlert.description.replace('{days}', String(daysRemaining))}
      </p>
      <div className="mt-auto self-end">
        <SubscribeButton
          variant="outline"
          size="sm"
          className="border-warning text-warning hover:opacity-90"
        />
      </div>
    </OrgAlert>
  );
}
